import TableContainer from "components/Common/TableContainer"
import moment from "moment"
import React, { useEffect, useMemo, useRef, useState } from "react"
import toast from "react-hot-toast"
import { Toast, ToastBody } from "reactstrap"
import {
  useDeletePermissionMutation,
  useLazyGetPermissionListQuery,
} from "store/api/permissions/permissions.api"
import CreatePermissionModal from "./createPermissionModal"
import { Link } from "react-router-dom"

const defaultFilters = {
  search: "",
  page: 1,
  pageSize: 20,
  timestamp: "",
}

const PermissionTable = () => {
  const [getResults, { isFetching }] = useLazyGetPermissionListQuery()
  const [open, setOpen] = useState(false)
  const [mutate] = useDeletePermissionMutation()
  const [data, setData] = useState([])
  const [isToast, setIsToast] = useState(false)
  const deleteRef = useRef(null)
  const [editDetails, setEditdetails] = useState(null)
  const [filters, setFilters] = useState(defaultFilters)
  //meta title
  document.title = "Permissions"

  const getList = async () => {
    try {
      const { data } = await getResults().unwrap()
      setData(data?.rows)
    } catch (e) {}
  }

  useEffect(() => {
    getList()
  }, [filters])

  const onCreateSuccess = () => {
    setFilters((prev) => ({ ...prev, page: 1, timestamp: moment().unix() }))
  }

  const onDeletePermission = async () => {
    const data = deleteRef?.current
    if (data) {
      try {
        const res = await mutate(data)
        if (res?.data.success) {
          toast.success(res.data.message, { id: "deleteSuccess" })
          deleteRef.current = null
          onCreateSuccess()
          setIsToast(false)
        }
      } catch (error) {}
    }
  }

  const onHandleCreatePermission = () => {
    setOpen(true)
    setEditdetails(null)
  }

  const columns = useMemo(
    () => [
      {
        header: "Id",
        accessorKey: "id",
        enableColumnFilter: false,
        enableSorting: true,
      },
      {
        header: "Module",
        accessorKey: "module",
        enableColumnFilter: false,
        enableSorting: true,
      },
      {
        header: "Label",
        accessorKey: "label",
        enableColumnFilter: false,
        enableSorting: true,
      },
      {
        header: "Key",
        accessorKey: "key",
        enableColumnFilter: false,
        enableSorting: true,
      },
      {
        id: "delete",
        header: "Delete",
        cell: ({ row }) => (
          <div
            className="d-flex justify-content-center align-items-center"
            onClick={() => {
              deleteRef.current = row?.original
              setIsToast(true)
            }}
          >
            <i className="dripicons-trash" />
          </div>
        ),
      },
      {
        id: "edit",
        header: "Edit",
        cell: ({ row }) => (
          <div
            className="d-flex justify-content-center align-items-center"
            onClick={() => {
              setEditdetails(row.original)
              setOpen(true)
            }}
          >
            <i className="dripicons-document-edit" />
          </div>
        ),
      },
    ],
    []
  )

  const FilterComponents = () => (
    <>
      <Link
        className="btn btn-secondary"
        to={"#"}
        onClick={() => onHandleCreatePermission()}
      >
        <i className="mdi mdi-plus me-1"></i> Create
      </Link>
    </>
  )

  return (
    <>
      <TableContainer
        isLoading={isFetching}
        filters={filters}
        isCustomPageSize
        setFilters={setFilters}
        columns={columns}
        data={data}
        FilterComponents={FilterComponents}
        isPagination={true}
        pagination="pagination"
        paginationWrapper="dataTables_paginate paging_simple_numbers"
        tableClass="table-bordered table-nowrap dt-responsive nowrap w-100 dataTable no-footer dtr-inline"
      />
      {open && (
        <CreatePermissionModal
          open={open}
          title={!editDetails ? "Create" : "Edit"}
          setOpen={setOpen}
          onCreateSuccess={onCreateSuccess}
          editData={editDetails}
        />
      )}

      {isToast && (
        <div
          className="position-fixed top-0 start-50 translate-middle-x p-3"
          style={{ zIndex: "1005" }}
        >
          <Toast isOpen={isToast} role="alert">
            <ToastBody>
              Are you sure you want to delete this permission?
              <div className="mt-2 pt-2 border-top">
                <button
                  type="button"
                  className="btn btn-primary btn-sm me-1"
                  onClick={onDeletePermission}
                >
                  Yes
                </button>
                <button
                  onClick={() => {
                    setIsToast(false)
                    deleteRef.current = null
                  }}
                  type="button"
                  className="btn btn-secondary btn-sm"
                >
                  No
                </button>
              </div>
            </ToastBody>
          </Toast>
        </div>
      )}
    </>
  )
}

export default PermissionTable
